import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import MultiSearchPanel from "../Search/MultiSearchPanel";
import { useService } from "../../context/ServiceContext";
import SeriesAccessoryWizard from "./SeriesAccessoryWizard";

function SeriesAccessorySearch({ onAccessorySelect, onSeriesSelect, accessorySelectText, seriesSelectText, onNoResults, hideEmpties }) {
  const {
    accessoryResultsLister,
    serieComercialAccessoryNameSuggester,
    serieComercialAccessorySuggester,
    serieComercialAccessoryHideEmptiesSuggester,
    serieComercialAccessoryNameHideEmptiesSuggester,
  } = useService();
  const intl = useIntl();

  let searchFields = [
    {
      id: "series",
      label: intl.formatMessage({
        id: "app.series",
        defaultMessage: "Series",
      }),
      value: "",
      suggester: hideEmpties ? serieComercialAccessoryHideEmptiesSuggester : serieComercialAccessorySuggester,
    },
    {
      id: "name",
      label: intl.formatMessage({
        id: "app.accessory",
        defaultMessage: "Accessory",
      }),
      value: "",
      suggester: hideEmpties ? serieComercialAccessoryNameHideEmptiesSuggester : serieComercialAccessoryNameSuggester,
    },
  ];

  const searchHandles = {
    series: {
      lister: accessoryResultsLister,
      step: "series",
      filter: (value) => ({ series: value, hideEmpty: hideEmpties }),
    },
    name: {
      lister: accessoryResultsLister,
      step: "name",
      filter: (value) => ({ name: value, hideEmpty: hideEmpties }),
    },
  };

  const [submittedSearch, setSubmittedSearch] = useState(null);

  async function handleSearchSubmit(search) {
    if (search !== null) {
      let handle = searchHandles[search.id];
      setSubmittedSearch({
        step: "accessories",
        filter: handle.filter(search.value),
      });
    } else {
      setSubmittedSearch(null);
    }
  }

  return (
    <>
      <Row>
        <Col>
          <MultiSearchPanel fields={searchFields} onSubmit={handleSearchSubmit} isOpen={true} onToggleOpen={() => {}} />
        </Col>
      </Row>
      {submittedSearch && (
        <Row className="mt-3">
          <Col>
            <Card>
              <CardHeader>
                <FormattedMessage id="app.results" defaultMessage="Results" />
              </CardHeader>
              <CardBody className="p-0">
                <SeriesAccessoryWizard
                  listers={{
                    accessories: accessoryResultsLister,
                  }}
                  search={submittedSearch}
                  onAccessorySelect={onAccessorySelect}
                  accessorySelectText={accessorySelectText}
                  onSeriesSelect={onSeriesSelect}
                  seriesSelectText={seriesSelectText}
                  onNoResults={onNoResults}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
}

export default SeriesAccessorySearch;
